@if ({ releaseInfo: releaseInfo$ | async }; as STATE) {
  <main
    elementBounding
    listenFor="all"
    cssVarName="footer"
    class="admin-footer"
  >
    <p class="admin-footer__info">
      <app-copyright class="admin-footer__copyright" />
    </p>
    @if (STATE.releaseInfo?.version; as version) {
      <p class="admin-footer__version">
        <span class="admin-footer__version-value">
          v{{ version || '' }}
          @if (STATE.releaseInfo?.date; as date) {
            ({{ date }})
          }
        </span>
      </p>
    }
  </main>
}
